import { FooterShell } from "./footer-shell"
import type { FooterShellProps } from "./footer-types"

export type MegaFooterProps = FooterShellProps

export function MegaFooter(props: MegaFooterProps) {
	return <FooterShell {...props} size="mega" />
}